import { ConfigFn } from '@config/types'

const config = (() =>
  ({
    localStorageHideFmtOnboardingContainerKeySelectTeamList:
      'ftm_onboarding_container_select_team_list',
    localStorageHideFmtOnboardingContainerKeyTeamsTab:
      'ftm_onboarding_container_teams_tab',
    moreInfoLink: '/id20932493.html',
  }) as const) satisfies ConfigFn

export default config
